import type { Event, Site } from "@/services";
import { eventSeverity } from "@/services";

export function buildSiteStatusMap(events: Event[]): Map<number, "warning" | "danger"> {
  const statusMap = new Map<number, "warning" | "danger">();
  for (const evt of events) {
    const bucket = eventSeverity(evt);
    const current = statusMap.get(evt.site.id);
    if (bucket === "critical") {
      statusMap.set(evt.site.id, "danger");
    } else if ((bucket === "warning" || bucket === "uncertain") && current !== "danger") {
      statusMap.set(evt.site.id, "warning");
    }
  }
  return statusMap;
}

export function countSiteStatuses(
  sites: Site[],
  statusMap: Map<number, "warning" | "danger">
): { normal: number; warning: number; danger: number } {
  const counts = { normal: 0, warning: 0, danger: 0 };
  for (const site of sites) {
    const status = statusMap.get(site.id);
    counts[status ?? "normal"]++;
  }
  return counts;
}
